<template>
  <TheLayout>
    <div v-if="allowView" class="custom_theo_design">
      <div class="row">
        <div class="col-12">
          <div
            class="
              page-title-box
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <b class="fs-16 text-bold"> DANH SÁCH KHOẢN PHẢI {{ getNameOfDebt(typeOfDebt, true) }} </b>
          </div>
        </div>
      </div>
      <div class="tab_group_custom mb-3 d-flex align-items-center">
        <a @click="getTabStatus(0)" :class="{ active: activeTab == 0 }" class="tab_link">Khoản chưa hoàn thành</a>
        <span class="border"></span>
        <a @click="getTabStatus(1)" :class="{ active: activeTab == 1 }" class="tab_link">Khoản đã hoàn thành</a>
      </div>
      <div v-if="activeTab == 0" class="mb-3">
        <baseReportSummary :dataReport="dataReport"/>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card order-list-tab">
            <div class="card-body">
              <div class="d-flex justify-content=between mb-3">
                <b-input-group class="wrapperInput">
                  <el-popover placement="bottom-start" width="530" trigger="click" v-model="showFilter">
                    <!-- slot -->
                    <div class="row d-flex align-items-center mb-3">
                      <div class="col-3 text-right">Ngày ghi nợ:</div>
                      <div class="col-9">
                        <el-date-picker
                          popper-class="custom-picked"
                          class="w-100"
                          type="daterange"
                          align="right"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          v-model="createdAtRange"
                          :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center mb-3">
                      <div class="col-3 text-right">Hạn trả:</div>
                      <div class="col-9">
                        <el-date-picker
                          popper-class="custom-picked"
                          class="w-100"
                          type="daterange"
                          align="right"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          v-model="dueAtRange"
                          :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center mb-3">
                      <div class="col-3 text-right">Người tạo:</div>
                      <div class="col-9">
                        <el-select class="w-100 prefix_show_only" v-model="createrId" placeholder="Tất cả">
                          <el-option v-for="item in listCreater" :key="item.id" :label="item.text" :value="item.id"> </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="row d-flex align-items-center mb-3">
                      <div class="col-3 text-right">Giao dịch với:</div>
                      <div class="col-9">
                        <!-- <el-select class="w-100 prefix_show_only" v-model="partnerSelectId" filterable clearable placeholder="Tất cả">
                          <el-option v-for="item in listPartner" :key="item.value" :label="item.fullNameSort + ' - ' + item.phoneNo" :value="item.id"> </el-option>
                        </el-select> -->
                        <el-select
                          class="w-100 prefix_show_only"
                          v-model="partnerSelectId"
                          filterable
                          clearable
                          remote
                          reserve-keyword
                          placeholder="Tất cả"
                          :remote-method="remoteMethod"
                          :loading="loadingSelect"
                        >
                          <el-option v-for="(item, i) in listPartner" :key="i" :label="item.name + ' - ' + item.phoneNo" :value="item.id"> </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="row d-flex align-items-center mb-3" v-if="tab[0] !== 'SETTLED'">
                      <div class="col-3 text-right">Trạng thái:</div>
                      <div class="col-9">
                        <el-select class="w-100 prefix_show_only" v-model="statusSelected" placeholder="Tất cả">
                          <el-option v-for="item in optionsStatus" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 d-flex justify-content-end">
                        <el-button @click="showFilter = false">Hủy</el-button>
                        <el-button type="danger" plain @click="resetFilter(), fetchData()">Xóa bộ lọc</el-button>
                        <el-button type="primary" @click="searchItem">Áp dụng bộ lọc</el-button>
                      </div>
                    </div>
                    <!-- reference -->
                    <!-- <el-button class="border-0" slot="reference" type="info" plain size=""> <i class="mdi mdi-filter-outline"></i> Bộ lọc </el-button> -->
                    <el-button style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                      <div class="justify-content-center align-items-center d-flex">
                        <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-filter-outline"></i></div> Bộ lọc
                      </div>
                    </el-button>
                  </el-popover>
                  <el-input @keyup.enter.native="searchDebt" v-model="text" class="ml-2" placeholder="Tìm kiếm..." prefix-icon="el-icon-search" style="width: 280px" clearable>
                  </el-input>
                  <!-- <div v-if="this.text.length > 0" class="removeText" @click.prevent="remove()">
                    ×
                  </div> -->
                </b-input-group>
                <el-button  @click="modalImport = true" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                  <div class="justify-content-center align-items-center d-flex">
                    <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Nhập dữ liệu
                  </div>
                </el-button>
                <el-button @click.native="exportData" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                  <div class="justify-content-center align-items-center d-flex">
                    <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Xuất dữ liệu
                  </div>
                </el-button>
                <el-button v-if="allowCreateDebt" @click="openModalDebt" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="primary">
                  <div class="justify-content-center align-items-center d-flex">
                    <div><i style="font-size:18px; margin-right:4px" class="fa-solid fa-plus"></i></div> Thêm khoản phải {{ getNameOfDebt(typeOfDebt) }}
                  </div>
                </el-button>
              </div>
              <div class="table-responsive mb-0" v-if="tab[0] !== 'SETTLED'">
                <ItemArrangeColumn v-model="fieldsUncomplete" />
                <b-table
                  head-variant="light"
                  responsive
                  tbody-tr-class="row-table-class"
                  hover
                  :items="dataDebt"
                  :fields="fieldsUncomplete.filter((e) => e.show)"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="myRowClickHandler"
                >
                  <template #head(edit)>
                    <img @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)" src="@/assets/images/icon/menu_option.svg" />
                  </template>
                  <template #table-caption>
                    <div v-if="dataDebt.length == 0" class="emptyData">
                      <p class="text-center">Danh sách khoản {{ getNameOfDebt(typeOfDebt) }} của bạn chưa có dữ liệu</p>
                    </div>
                  </template>

                  <template #cell(balance)="data">
                    <div style="white-space: nowrap">
                      {{ formatMoney(divisionThousand(data.item.balance)) }}
                    </div>
                  </template>

                  <template #cell(repay)="data">
                    <base-payment-status :status="data.item.repay > 0 ? 'PAYING' : 'UNPAID'" />
                  </template>

                  <template #cell(principal)="data">
                    <div style="margin: 0px; white-space: nowrap">
                    {{ formatMoney(divisionThousand(data.item.principal)) }}
                    </div>
                  </template>

                  <template #cell(status)="data">
                    <StatusBox class="m-auto" :status="getStatus(data.item.status).status" :showText="getStatus(data.item.status).text"></StatusBox>
                  </template>

                  <template #cell(dueAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.dueAt | formatDate }}
                    </p>
                  </template>

                  <template #cell(createdAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.createdAt | formatDate }}
                    </p>
                  </template>

                  <template #cell(createdBy)="data">
                    <p style="margin: 0px">
                      {{ data.item.createdBy && mapListCreater[data.item.createdBy] ? mapListCreater[data.item.createdBy].text : "---" }}
                    </p>
                  </template>

                  <template #cell(edit)="data" no-select-on-click>
                    <IconEditRecord v-if="true" @click.native.stop :options="optionSelect" @select="chooseOption($event, data.item)" />
                  </template>
                </b-table>
              </div>
              <div class="table-responsive mb-0" v-else>
                <ItemArrangeColumn v-model="fieldsComplete" />
                <b-table
                  tbody-tr-class="row-table-class"
                  hover
                  :items="dataDebt"
                  :fields="fieldsComplete.filter((e) => e.show)"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="myRowClickHandler"
                >
                  <template #head(edit)>
                    <img @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)" src="@/assets/images/icon/menu_option.svg" />
                  </template>
                  <template #table-caption>
                    <div v-if="dataDebt.length == 0" class="emptyData">
                      <p class="text-center">Danh sách khoản {{ getNameOfDebt(typeOfDebt) }} của bạn chưa có dữ liệu</p>
                    </div>
                  </template>

                  <template #cell(principal)="data">
                    <p style="margin: 0px; white-space: nowrap">
                      {{ formatMoney(divisionThousand(data.item.principal)) }}
                    </p>
                  </template>

                  <template #cell(dueAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.dueAt | formatDate }}
                    </p>
                  </template>

                  <template #cell(createdBy)="data">
                    <p style="margin: 0px">
                      {{ data.item.createdBy && mapListCreater[data.item.createdBy] ? mapListCreater[data.item.createdBy].text : "---" }}
                    </p>
                  </template>

                  <template #cell(createdAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.createdAt | formatDate }}
                    </p>
                  </template>

                </b-table>
              </div>

              <div class="DebtAccomplish-body-pagination">
                <div class="pagination-text">
                  <span style="width: 50px">Hiển thị </span>

                  <b-form-select v-model="perPage" :options="optionsPerPage" style="width: 72px; height: 32px"> </b-form-select>

                  <span style="width: 276px" v-if="dataDebt.length === 0" class="tx-pagination">
                    kết quả từ 0 - {{ dataDebt.length }} trên tổng {{ dataDebt.length }} khoản phải {{ getNameOfDebt(typeOfDebt) }}
                  </span>
                  <span style="width: 276px; margin-left: 5px" class="tx-pagination" v-if="dataDebt.length < numberPage * perPage && dataDebt.length > 0">
                    kết quả từ {{ numberPage * perPage - perPage + 1 }} - {{ dataDebt.length }} trên tổng {{ dataDebt.length }} khoản phải {{ getNameOfDebt(typeOfDebt) }}
                  </span>
                  <span style="width: 276px; margin-left: 5px" class="tx-pagination" v-if="dataDebt.length > 0 && dataDebt.length >= numberPage * perPage">
                    kết quả từ {{ numberPage * perPage - perPage + 1 }} - {{ numberPage * perPage }} trên tổng {{ dataDebt.length }} khoản phải {{ getNameOfDebt(typeOfDebt) }}
                  </span>
                </div>

                <b-pagination
                  :total-rows="rows"
                  v-model="currentPage"
                  :per-page="perPage"
                  aria-controls="debt-table"
                  hide-goto-end-buttons
                  limit="5"
                  last-text="next"
                  align="right"
                  @input="callPageNumber(currentPage)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>

      <b-modal modal-class="custom_theo_design" id="modal-debt" no-close-on-backdrop v-model="showModalDebt">
        <template #modal-header>
          <h4 class="title-modal-addDebt mb-0">Thêm khoản {{ getNameOfDebt(typeOfDebt) }}</h4>
          <button type="button" aria-label="Close" class="close" @click="openModalDangerOfDebt">
            <i class="el-icon-close"></i>
          </button>
        </template>

        <div class="modal-input" id="modal-add-debtnote">
          <label for="input-content">Tên khoản {{ getNameOfDebt(typeOfDebt) }} <span style="color: red">*</span></label>

          <b-form-input id="input-content" :placeholder="`Nhập tên khoản ${getNameOfDebt(typeOfDebt)}`" v-model="paramModalAddDebt.title" />

          <p class="text-danger" v-if="messageError.title">
            {{ messageError.title }}
          </p>
        </div>

        <div class="modal-input">
          <!-- <label for="input-typesOfDebt">Loại công nợ <span style="color: red">*</span></label>

          <Select2 placeholder="Chọn loại công nợ" v-model="typeOfDebtInComponent" @select="selectTypeOfDebt($event)" :options="typesOfDebt" />
          <p class="text-danger" v-if="messageError.type">
            {{ messageError.type }}
          </p> -->
        </div>

        <div class="modal-input">
          <label for="input-content">Giao dịch với <span style="color: red">*</span></label>
          <b-row>
            <b-col>
              <el-select
                class="custom-input-77"
                style="width: 326px"
                v-model="partnerId"
                filterable
                clearable
                remote
                reserve-keyword
                placeholder="Nhập tên/ID/Email/Số điện thoại"
                :remote-method="remoteMethod"
                :loading="loadingSelect"
              >
                <el-option v-for="(item, i) in listPartner" :key="i" :label="customLabel(item)" :value="item.id"> </el-option>
              </el-select>
              <el-button type="primary" class="float-right" v-if="allowAddFast" @click="modalNewCustomer = true">
                Thêm nhanh
              </el-button>
            </b-col>
          </b-row>

          <p class="text-danger" v-if="messageError.nanme">
            {{ messageError.nanme }}
          </p>
        </div>

        <div class="modal-input">
          <label for="input-total">Tổng phải {{ getNameOfDebt(typeOfDebt) }} <span style="color: red">*</span></label>
          <!-- <b-form-input id="input-total" :placeholder="'Nhập số tiền phải '+ getNameOfDebt(typeOfDebt)" class="w-100" v-model="total" @keydown="allowNumbersOnly" /> -->

          <!-- <Select2 v-model="paramModalAddDebt.currency" :options="units" style="width: 20%" /> -->
          <InputMoneyVmodel id="input-total" :placeholder="'Nhập số tiền phải '+ getNameOfDebt(typeOfDebt)" class="form-control" v-model="total"></InputMoneyVmodel>


          <p class="text-danger" v-if="messageError.principal">
            {{ messageError.principal }}
          </p>
        </div>

        <div class="modal-input">
          <div class="modal-input-element">
            <label for="input-date-left"> Ngày ghi nợ </label>
            <el-date-picker size="medium" class="w-100" v-model="dateFromOfModal" type="date" placeholder="Thời gian từ"> </el-date-picker>
          </div>

          <div class="modal-input-element">
            <label for="input-content-right">Hạn trả</label>
            <el-date-picker size="medium" class="w-100" v-model="dateToOfModal" type="date" placeholder="Thời gian đến"> </el-date-picker>
          </div>
        </div>
        <!-- <p class="text-danger text-end" v-if="messageError.dueAt">
          {{ messageError.dueAt }}
        </p> -->

        <div class="modal-input">
          <label for="input-note"> Ghi chú </label>
          <b-form-textarea id="input-note" placeholder="Nhập thông tin ghi chú" v-model="paramModalAddDebt.note" />
        </div>

        <template #modal-footer>
          <button type="button" class="mgr-15 text-primary" @click="openModalDangerOfDebt">
            Thoát
          </button>
          <el-button type="primary" @click="submitAddDebt">
            Hoàn tất
          </el-button>
        </template>
      </b-modal>

      <!-- MODAL 1 -->
      <b-modal modal-class="custom_theo_design" id="editDetailDebt" hide-footer no-close-on-backdrop>
        <template #modal-header>
          <h4 class="title-modal-addDebt mb-0">Chỉnh sửa khoản {{ getNameOfDebt(typeOfDebt) }}</h4>
          <button type="button" aria-label="Close" class="close" @click="closeModalUpdate">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <b-form-group>
          <label>Tên khoản {{ getNameOfDebt(typeOfDebt) }}<span class="text-danger"> * </span></label>
          <b-form-input v-model="dataDetailTmp.title" type="text" placeholder="Nhập nội dung"></b-form-input>
          <p class="text-danger" v-if="messEror.title">{{ messEror.title }}</p>
        </b-form-group>

        <b-form-group>
          <label>Người ghi nợ</label>
          <b-form-input v-model="dataDetailTmp.partner.partnerDisplayName" type="text" disabled></b-form-input>
        </b-form-group>

        <b-form-group>
          <label>Tổng phải {{ getNameOfDebt(typeOfDebt) }}</label>
          <div class="input-group">
            <b-form-input :value="formatMoneyNotUnit(dataDetailTmp.principal)" class="form-control" disabled placeholder="0"></b-form-input>
          </div>
          <p class="text-danger" v-if="messEror.principal">{{ messEror.principal }}</p>
        </b-form-group>

        <b-form class="d-flex justify-content-between">
          <b-form-group label="Ngày ghi nợ" class="col-6 pl-0">
            <div v-if="minDate != '' && Date.parse(minDate) < Date.parse(dueAt)">
              <date-picker
                type="date"
                placeholder="Ngày bắt đầu"
                :default-value="new Date().setHours(24, 0, 0, 0)"
                :disabled-date="($event) => (minDate ? $event > new Date(minDate) : false)"
                value-type="format"
                v-model="startAt"
                @change="getDateFromOfModal(startAt)"
              ></date-picker>
            </div>

            <div v-else>
              <date-picker
                type="date"
                placeholder="Ngày bắt đầu"
                :default-value="new Date().setHours(24, 0, 0, 0)"
                :disabled-date="($event) => (dueAt ? $event > new Date(dueAt) : false)"
                value-type="format"
                v-model="startAt"
                @change="getDateFromOfModal(startAt)"
              ></date-picker>
            </div>
            <p class="text-danger" v-if="messEror.dueAt">{{ messEror.dueAt }}</p>
          </b-form-group>

          <b-form-group class="col-6 pr-0">
            <label>Hạn trả<span class="text-danger"> * </span></label>
            <date-picker
              type="date"
              placeholder="Ngày hoàn trả"
              :default-value="new Date().setHours(24, 0, 0, 0)"
              :disabled-date="disableForDueAt"
              value-type="format"
              v-model="dueAt"
              :clearable="false"
              @change="getDateToOfModal(dueAt)"
            ></date-picker>
          </b-form-group>
        </b-form>

        <b-form-group label="Ghi chú">
          <textarea class="form-control" placeholder="Nhập thông tin ghi chú" v-model="dataDetailTmp.note" />
        </b-form-group>

        <div class="w-100 text-right">
          <button type="button" class="mgr-15 text-primary" @click="closeModalUpdate">
            Thoát
          </button>
          <el-button type="primary" @click="clickEdit()">
            Hoàn tất
          </el-button>
        </div>
      </b-modal>
      <!--MODAL 2-->
      <b-modal modal-class="custom_theo_design" id="modal-pay" hide-footer no-close-on-backdrop>
        <template #modal-header>
          <h4 class="title-modal-addDebt mb-0">Thêm thanh toán</h4>
          <button type="button" aria-label="Close" class="close" @click="closeModalDanger">
            <i class="el-icon-close"></i>
          </button>
        </template>

        <div class="row">
          <div class="col-6">
            <b-form-group>
              <label>Ngày trả nợ<span class="text-danger"> * </span></label>

              <date-picker
                v-model="dateOfModal"
                type="date"
                placeholder="Chọn ngày"
                :default-value="new Date().setHours(24, 0, 0, 0)"
                :disabled-date="check()"
                value-type="format"
                :clearable="false"
                @change="getDateOfModalAddPay(dateOfModal)"
              ></date-picker>

              <p class="text-danger" v-if="messEror.dateOfModal">
                {{ messEror.dateOfModal }}
              </p>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group>
              <label>Hình thức trả</label>

              <Select2 v-model="formOfPayment" :options="formOfPayments" @select="changeFormOfPayment($event)" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group>
              <label>Số tiền<span class="text-danger"> * </span></label>
              <div>
                <InputMoneyVmodel :max="dataDetail.balance" class="form-control" v-model="total"></InputMoneyVmodel>
              </div>
              <p class="text-danger" v-if="messEror.total">{{ messEror.total }}</p>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group>
              <label>Mã tham chiếu</label>
              <div>
                <b-form-input v-model="referenceCode" class="form-control" placeholder="Nhập mã tham chiếu"></b-form-input>
              </div>
            </b-form-group>
          </div>
        </div>

        <b-form-group label="Ghi chú">
          <textarea v-model="paramAddPay.note" class="form-control" placeholder="Nhập thông tin ghi chú"> </textarea>
        </b-form-group>

        <div class="d-flex justify-content-end w-100">
          <div class="d-flex justify-content-betweem">
            <button type="button" class="mgr-15 text-primary" @click="closeModalDanger">
              Thoát
            </button>
            <el-button type="primary" v-if="dataPermission && dataPermission.includes('NSH_DEBT_PAYMENT')" @click="submitAddPay">
              Hoàn tất
            </el-button>
          </div>
        </div>
      </b-modal>

      <b-modal modal-class="custom_theo_design" id="modal-pay-confirm" hide-footer no-close-on-backdrop>
        <template #modal-header>
          <h4 class="title-modal-addDebt mb-0">Xác nhận thanh toán</h4>
          <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('modal-pay-confirm')">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <div class="my-3 text-center">
          <img class="mb-3" src="@assets/order-icon/Accept-order.png" />
          <div class="text-center">
            Bạn chắc chắn muốn thanh toán <b>{{ formatMoneyNotUnit(total) }}</b> cho khoản nợ?<br />
            Thao tác này không thể khôi phục.
          </div>
        </div>

        <div class="d-flex justify-content-end w-100">
          <div class="d-flex justify-content-betweem">
            <button type="button" class="mgr-15 text-primary" @click="$bvModal.hide('modal-pay-confirm')">
              Thoát
            </button>
            <el-button type="primary" v-if="dataPermission && dataPermission.includes('NSH_DEBT_PAYMENT')" @click="submitAddPayConfirm">
              Hoàn tất
            </el-button>
          </div>
        </div>
      </b-modal>

      <!-- Modal add Customer -->
      <b-modal modal-class="custom_theo_design" v-model="modalNewCustomer" centered hide-footer no-close-on-backdrop>
        <template #modal-header>
          <h4 class="title-modal-addDebt mb-0">Thêm mới khách hàng/NCC</h4>
          <button type="button" aria-label="Close" class="close" @click="cancelAdd">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <!-- <button @click="cancelAdd()" type="button" aria-label="Close" class="close close-ext">
          <i class="el-icon-close"></i>
        </button>
        <div class="text-title-modal mb-3 text-bold">Thêm mới khách hàng/NCC</div> -->
        <validation-observer ref="observerCustomer" v-slot="{ validate }">
          <RowWrapper>
            <template #center>
              <RowWrapper>
                <template #center>
                  <b-form-group id="input-group-1" label="" label-for="">
                    <label>Phân loại</label>
                    <el-select class="w-100" v-model="type" placeholder="Chọn phân loại">
                      <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </b-form-group>
                </template>
              </RowWrapper>

              <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-groupname-input">
                    <validation-provider name="Họ và tên" rules="required|lBetween:1,255|CHECK_HTML" v-slot="{ errors, valid }">
                      <label>Họ và tên<sup class="text-danger"> * </sup></label>
                      <b-form-input
                        id="formrow-groupname-input"
                        type="text"
                        placeholder="Họ và tên"
                        v-model="dataPartner.name"
                        :state="errors[0] ? false : valid ? true : null"
                        @keydown.enter.prevent
                      />

                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper>

              <!-- <RowWrapper>
                <template #center>
                  <b-form-group id="input-group-1" label="" label-for="">
                    <label>Nhóm khách hàng</label>
                    <multiselect
                      placeholder="Chọn phân loại"
                      label="text"
                      track-by="id"
                      v-model="dataPartner.person"
                      :options="listType"
                      deselectLabel=""
                      selectLabel=""
                      selectedLabel=""
                      :clear-on-select="false"
                      :preserve-search="true"
                      :allow-empty="false"
                    >
                      <template slot="noOptions"> Chưa có dữ liệu </template>
                    </multiselect>
                  </b-form-group>
                </template>
              </RowWrapper> -->

              <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-groupname-input">
                    <validation-provider name="Số điện thoại" rules="required|PHONE_NO_3|CHECK_HTML|lBetween:1,15" v-slot="{ errors, valid }">
                      <label>Số điện thoại<sup class="text-danger"> * </sup></label>
                      <b-form-input
                        id="formrow-phone-input"
                        type="text"
                        placeholder="Nhập số điện thoại"
                        v-model.trim="dataPartner.phoneNo"
                        @keydown.enter.prevent
                        @keydown="allowNumbersOnly"
                        :state="errors[0] ? false : valid && dataPartner.phoneNo != null ? true : null"
                      />
                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper>

              <!-- <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-email-input">
                    <validation-provider name="Email" rules="EMAIL|CHECK_HTML|lBetween:6,255" v-slot="{ errors, valid }">
                      <label>Địa chỉ email</label>
                      <b-form-input
                        id="formrow-email-input"
                        type="text"
                        placeholder="Nhập địa chỉ email"
                        v-model.trim="dataPartner.email"
                        trim
                        :state="errors[0] ? false : valid && dataPartner.email != null && dataPartner.email != '' ? true : null"
                      />
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper> -->
            </template>
          </RowWrapper>

          <div class="row">
            <div class="d-flex justify-content-end m-2 w-100">
              <button type="button" class="mgr-15 text-primary" @click="cancelAdd">
                Thoát
              </button>
              <el-button type="primary" class="btn btn-primary" @click.prevent="saveItem(validate)">
                Hoàn tất
              </el-button>
            </div>
          </div>
        </validation-observer>
      </b-modal>

      <!--Modal import-->
      <b-modal id="modal-scoped" v-model="modalImport" no-close-on-backdrop>
        <template #modal-header="{}">
          <h5 class="mb-0">
            <p style="font-weight: bold">Nhập dữ liệu khoản {{ getNameOfDebt(typeOfDebt) }}</p>
          </h5>
          <button type="button" size="sm" aria-label="Close" class="close" @click="cancels()">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <template #default>
          <ul class="dotUL ml-4">
            <li>
              Tải file mẫu
              <a href="/assets/files/ReportDebtNote.xlsx">tại đây</a> (Cập nhật ngày 22/12/2021)
            </li>
            <li>File có định dạng .XLSX và giới hạn 3000 dòng</li>
          </ul>
          <label class="step-content" tabindex="0" for="file">
            <div class="input-file-containers">
              <input class="input-file" style="display: none" id="file" @change="uploadFileExcel" ref="file" type="file" accept=".xlsx,.xls,.csv" />
              <p v-if="messFailFormat" class="color-red"><i class="bx bxs-cloud-upload mr-2"></i> {{ messFailFormat }}</p>
              <p v-if="keyCheckUpload == 0 && messFailFormat == ''"><i class="bx bxs-cloud-upload mr-2"></i> Kéo thả file hoặc tải lên từ thiết bị</p>
              <p v-if="keyCheckUpload == 1" class="text-bold text-dark"><i class="bx bxs-cloud-upload mr-2"></i> File: {{ fileName }}</p>
            </div>
          </label>
        </template>

        <template #modal-footer="{}">
          <div class="d-flex justify-content-between w-100 m-0">
            <b-button variant="danger" size="md" class="m-0" @click="cancels()">Hủy </b-button>
            <b-button variant="primary" size="md" class="m-0" v-if="isUpload"><i class="fas fa-spinner fa-spin"></i> Đang tải</b-button>
            <b-button variant="primary" size="md" class="m-0" v-if="!isUpload" @click="importData">Hoàn tất</b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>

<script>
import moment from "moment";
import Select2 from "v-select2-component";
import Swal from "sweetalert2";
import { DebtService } from "@/services/nextshop/debt.service";
import { PartnerService } from "@/services/nextshop/partner.service";
import { CustomerServices } from "@/services/nextshop/customer.service";
import { SupplierServices } from "@/services/nextshop/supplier.service";
import RowWrapper from "@/components/wrappers/RowWrapper";
import { formatMoney } from "@/utils/mapping.js";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import StatusBox from "@/components/status-box.vue";
import DatePicker from "vue2-datepicker";
import InputMoneyVmodel from "../../orders-return/components/inputMoneyVmodel.vue";
import { getStatus, getListCreater, arrayToObjectKey } from "../utils.js";
import _ from "lodash"
import baseReportSummary from '@/components/base-report-summary.vue'
import { ReportService } from "@/services/nextshop/report.service";
import VueCookies from 'vue-cookies'

export default {
  components: {
    Select2,
    RowWrapper,
    ItemArrangeColumn,
    StatusBox,
    DatePicker,
    InputMoneyVmodel,
    baseReportSummary
  },
  props: {
    typeOfDebt: {
      type: String,
      default: "borrowing",
    },
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentUser")),
      coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
      LID: JSON.parse(localStorage.getItem("LID")),
      MID: VueCookies.get("MID"),
      loading: false,
      loadingSelect: false,
      isActiveButton: false,
      typeAddNewSuccess: "",
      params: this.$route.params,

      // Logical bug handling for search partner "Giao dich voi"
      keyFake: "",
      keyConfilmSeclectPartner: false,

      // show modal
      showModalQuick: false,
      showModalDebt: false,
      // showModal: false,

      // modal add new debt
      key: "",
      total: "",
      dateFromOfModal: this.getStartTimeToday(),
      dateToOfModal: null,

      // filter page
      startAt: "",
      endAt: "",
      text: "",
      output: "",
      dateRange: {
        startDate: null,
        endDate: null,
      },

      // change tabs
      tabs: [
        {
          id: 1,
          tab: "Khoản chưa hoàn thành",
          content: ["OPEN"],
        },
        {
          id: 2,
          tab: "Khoản đã hoàn thành",
          content: ["SETTLED"],
        },
      ],
      
      tab: ["OPEN"],
      activeTab: 0,
      activeItem: {},

      paramAddPay: {
        repayAmount: 0,
        note: "",
        currency: "VND",
        occurAt: "",
        id: "",
        source: "other",
        sourceId: "",
        sourceKey: "",
      },

      // select option record/page
      optionsPerPage: [
        { value: "10", text: "10" },
        { value: "20", text: "20" },
        { value: "30", text: "30" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
      ],
      currentPage: 1,
      perPage: 10,
      lastIndex: "",
      numberPage: 1,

      // select option
      units: [{ id: "VND", text: "VNĐ" }],
      // typeOfDebtInComponent: this.typeOfDebt,
      typesOfDebt: [
        { id: "lending", text: "Khoản phải thu" },
        { id: "borrowing", text: "Khoản phải trả" },
      ],
      typeOfCustomer: 0,
      listType: [
        { id: true, text: "Cá nhân" },
        { id: false, text: "Doanh nghiệp" },
      ],

      // param add new debtnote
      paramModalAddDebt: {
        dueAt: "",
        principal: 0,
        type: "",
        title: "",
        partner: {
          partnerId: "",
          partnerDisplayName: "",
          partnerRelationship: "",
          name: "",
        },
        currency: "VND",
        note: "",
      },

      // param add new partner
      paramModalAddPartner: {
        name: "",
        phoneNo: null,
        email: null,
        isPerson: true,
      },
      listSelectPartner: [],

      // message validate
      messageError: {
        title: "",
        type: "",
        dueAt: "",
        name: "",
        email: "",
        phone: "",
        typeOfCustomer: "",
      },

      // b-table debtnote
      fieldsUncomplete: [
        // {
        //   key: "id",
        //   label: "Mã khoản " + this.getNameOfDebt(this.typeOfDebt),
        //   show: true,
        // },
        {
          key: "name",
          label: "Giao dịch với",
          show: true,
        },
        {
          key: "principal",
          label: "Tổng phải " + this.getNameOfDebt(this.typeOfDebt),
          thClass: "text-right",
          tdClass: "text-right",
          show: true,
        },
        {
          key: "repay",
          label: "Thanh toán",
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
        {
          key: "balance",
          label: "Còn lại",
          thClass: "text-right",
          tdClass: "text-right",
          show: true,
        },
        {
          key: "status",
          label: "Trạng thái",
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
        {
          key: "createdAt",
          label: "Ngày ghi nợ",
          show: false,
        },
        {
          key: "dueAt",
          label: "Hạn trả",
          show: true,
        },
        // {
        //   key: "paymentStatus",
        //   label: "Số lượt thanh toán",
        //   show: false,
        // },
        {
          key: "createdBy",
          label: "Người tạo",
          show: false,
        },
        {
          label: "",
          key: "edit",
          thStyle: { minWidth: "20px", padding: 0 },
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
      ],
      fieldsComplete: [
        // {
        //   key: "id",
        //   label: "Mã khoản " + this.getNameOfDebt(this.typeOfDebt),
        //   show: true,
        // },
        {
          key: "name",
          label: "Giao dịch với",
          show: true,
        },
        {
          key: "principal",
          label: "Tổng phải " + this.getNameOfDebt(this.typeOfDebt),
          thClass: "text-right",
          tdClass: "text-right",
          show: true,
        },
        {
          key: "createdAt",
          label: "Ngày ghi nợ",
          show: true,
        },
        {
          key: "dueAt",
          label: "Ngày tất toán",
          show: true,
        },
        // {
        //   key: "paymentStatus",
        //   label: "Số lượt thanh toán",
        //   show: true,
        // },
        {
          key: "createdBy",
          label: "Người tạo",
          show: true,
        },
        {
          label: "",
          key: "edit",
          thStyle: { minWidth: "20px", padding: 0 },
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
      ],
      dataDebt: [],
      // Update code
      modalNewCustomer: false,
      inforAccount: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      types: [
        {
          id: "CUSTOMER",
          text: "Khách hàng",
        },
        {
          id: "SUPPLIER",
          text: "Nhà cung cấp",
        },
        {
          id: "SHIPPER",
          text: "Shipper",
        },
      ],
      type: "CUSTOMER",
      dataPartner: {
        name: "",
        person: { id: true, text: "Cá nhân" },
      },
      partner: null,
      partnerId: null,
      listPartner: [],
      modalImport: false,
      search: {
        merchantId: JSON.parse(localStorage.getItem("auth.currentUser")).merchantId,
      },
      formData: null,
      messFailFormat: "",
      keyCheckUpload: 0,
      fileName: "",
      isUpload: false,

      // moi
      showFilter: false,
      visibleEditShow: false,

      // select option
      pickerOptions: this.getPickerOptions(),
      dueAtRange: null,
      createdAtRange: null,
      updatedAtRange: "",
      saleChannel: "",
      createrId: "",
      listCreater: [],
      mapListCreater: null,
      partnerSelectId: "",
      optionsSaleChannel: [
        {
          text: "Tất cả",
          value: "",
        },
        {
          text: "Người1",
          value: "1",
        },
        {
          text: "Người2",
          value: "2",
        },
        {
          text: "Người3",
          value: "3",
        },
      ],
      statusSelected: "",
      optionsStatus: [
        {
          text: "Chưa thanh toán",
          value: "OPEN",
        },
        {
          text: "Thanh toán 1 phần",
          value: "REPAYING",
        },
        {
          text: "Quá hạn",
          value: "OVERDUE",
        },
      ],

      optionSelect: [
        { id: 1, text: "Thêm thanh toán" },
        { id: 2, text: "Sửa thông tin" },
      ],
      typesDebt: [
        { id: "lending", text: "Khoản phải thu" },
        { id: "borrowing", text: "Khoản phải trả" },
      ],
      typesCurrency: [{ id: "VND", text: "VND" }],
      formOfPayment: "cash",
      referenceCode: "",
      formOfPayments: [
        { id: "cash", text: "Tiền mặt" },
        { id: "remittance", text: "Chuyển khoản" },
      ],
      dataDetail: {
        partner: {
          partnerDisplayName: "",
          partnerId: "",
        },
      },

      dataDetailTmp: {
        currency: "",
        id: "",
        status: "",
        title: "",
        type: "",
        startAt: "",
        dueAt: "",
        principal: "",
        note: "",
        partner: {
          partnerDisplayName: "",
        },
      },
      messEror: {
        dateOfModal: "",
        total: "",
        dueAt: "",
        title: "",
        principal: "",
      },
      dueAt: "",
      minDate: "",
      dateOfModal: new Date().toISOString().slice(0, 10),
      dataReport: [
        {
          text: `Tổng khoản ${this.getNameOfDebt(this.typeOfDebt)}`,
          value: 0
        },
        {
          text: `Còn lại chưa ${this.getNameOfDebt(this.typeOfDebt)}`,
          value: 0
        }
      ]
    };
  },

  created() {
    this.fetchData();
    this.getListCreaterInHere();
    this.mcReportV3();
  },

  computed: {
    rows() {
      return this.dataDebt.length;
    },
    allowAddFast() {
      return this.dataPermission.includes("NSH_PARTNER_SUP_CREATE") || this.dataPermission.includes("NSH_PARTNER_CUS_CREATE");
    },
    allowCreateDebt() {
      return this.dataPermission.includes("NSH_DEBT_CREATE");
    },
    allowView() {
      return this.dataPermission.includes("NSH_DEBT_VIEW");
    },
  },

  watch: {
    key: {
      handler: function() {
        this.listSelectPartner.splice(0, this.listSelectPartner.length);
        if (this.key === this.keyFake) {
          this.keyFake = "";
          this.keyConfilmSeclectPartner = true;
        } else {
          this.searchPartner();
          this.keyFake = "";
          this.keyConfilmSeclectPartner = false;
        }
      },
      deep: true,
    },

    lastIndex: {
      handler: function() {
        this.fetchData();
      },
      deep: true,
    },
    text: _.debounce(function() {
      if (this.text == "") this.fetchData();
    },700)
  },

  methods: {
    searchItem() {
      // console.log("seẢCH");
      this.showFilter = false;
      this.currentPage = 1;
      this.fetchData();
    },
    resetFilter() {
      this.currentPage = 1;
      this.dueAtRange = null;
      this.createdAtRange = null;
      this.updatedAtRange = "";
      this.saleChannel = "";
      this.partnerSelectId = "";
      this.createrId = "";
      this.statusSelected = "";
      // this.fetchData();
    },
    getStatus,

    // Sửa text option được chọn
    customLabel({ name, phoneNo }) {
      return `${name} - ${phoneNo}`;
    },

    // chọn partner
    partnerSelect($event) {
      console.log($event);
      this.paramModalAddDebt.PartnerService;
    },

    //xoa text trong o tim kiem
    async remove() {
      this.text = "";
      await this.fetchData();
    },

    // link to detail page
    myRowClickHandler(record) {
      this.$router.push({ path: `/debt_detail/${record.id}` });
    },

    // format money
    moneyFormatter(val) {
      // if (val == 0) {
      //   val = "";
      // }
      // val = val.toString().split(",").join("");
      // this.$emit("input", val);

      // let output = "";
      // while (val.length >= 3) {
      //   const last3Digits = val.slice(val.length - 3, val.length);
      //   val = val.slice(0, val.length - 3);
      //   output = "," + last3Digits + output;
      // }
      // if (val.length === 0) {
      //   output = output.slice(1, output.length);
      // } else {
      //   output = val + output;
      // }
      this.output = formatMoney(val);
    },

    moneyTotalFormatter(val) {
      this.moneyFormatter(val);
      this.total = this.output;
    },

    moneyFromFormatter(val) {
      this.moneyFormatter(val);
    },

    moneyToFormatter(val) {
      this.moneyFormatter(val);
    },

    // allow input number only
    allowNumbersOnly($event) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes($event.key) && $event.keyCode !== 8) {
        $event.preventDefault();
      }
    },

    // clear data when close modal add debtnote
    clearInputDataModalDebt() {
      (this.isActiveButton = false), (this.dateToOfModal = "");
      // this.dateFromOfModal = "";
      this.paramModalAddDebt.title = "";
      this.paramModalAddDebt.currency = "VND";
      this.paramModalAddDebt.note = "";
      this.paramModalAddDebt.startAt = null;
      this.paramModalAddDebt.dueAt = "";
      this.key = "";
      this.keyConfilmSeclectPartner = false;
      this.total = "";
      this.listSelectPartner.splice(0, this.listSelectPartner.length);
      this.messageError = new Object();
      this.dateToOfModal = null;
      this.dateFromOfModal = this.getStartTimeToday();
    },

    // clear data modal add partner
    clearInputDataModalPartner() {
      (this.isActiveButton = false), (this.paramModalAddPartner.name = "");
      this.typeOfCustomer = 0;
      this.paramModalAddPartner.phoneNo = null;
      this.paramModalAddPartner.email = null;
      this.messageError = new Object();
    },

    // click change page
    callPageNumber(item) {
      this.numberPage = item;
    },

    // Chuyển tab
    getTabStatus(tab) {
      // console.log(this.tabs, tab)
      // return
      this.activeTab = tab;
      switch (tab) {
        case 0:
          this.tab = ["OPEN"];
          break;
        case 1:
          this.tab = ["SETTLED"];
          break;
        default:
          this.tab = [];
          console.log("can not get tab");
          break;
      }
      this.resetFilter();

      if (this.dataDebt.length === 0) {
        this.fetchData();
        return;
      }

      if (this.dataDebt.length > 0 && this.dataDebt.length <= 100) {
        this.dataDebt.splice(0, this.dataDebt.length);
        this.fetchData();
        return;
      }

      if (this.dataDebt.length > 100) {
        this.dataDebt.splice(0, this.dataDebt.length);
        this.lastIndex = "";
        return;
      }
    },

    // open modal debt
    openModalDebt() {
      this.clearInputDataModalDebt();
      this.partner = null;
      this.typeOfDebtInComponent = this.typeOfDebt;
      this.$bvModal.show("modal-debt");
      this.listSelectPartner.splice(0, this.listSelectPartner.length);
    },
    //open modal danger of modal add partner
    // openModalDangerOfPartner() {
    //   if (this.paramModalAddPartner.name != "" || this.paramModalAddPartner.phoneNo != null || this.paramModalAddPartner.email != null) {
    //     this.$bvModal.show("modal-danger");
    //   } else {
    //     this.$bvModal.hide("modal-quick");
    //     this.clearInputDataModalPartner();
    //   }
    // },

    //open modal danger of modal add debt
    openModalDangerOfDebt() {
      // if (this.paramModalAddDebt.dueAt != "" || this.total > 0 || this.paramModalAddDebt.title != "" || this.paramModalAddDebt.note != "" || this.key != "") {
      //   this.$bvModal.show("modal-danger");
      // } else {
      //   this.$bvModal.hide("modal-debt");
      //   this.clearInputDataModalDebt();
      // }
      this.$bvModal.hide("modal-debt");
      this.clearInputDataModalDebt();
    },

    // close modal danger
    closeModalDanger() {
      this.$bvModal.hide("modal-pay");

      if (this.showModalQuick && this.showModalDebt) {
        this.showModalQuick = false;
        this.clearInputDataModalPartner();
      } else {
        this.showModalDebt = false;
        this.clearInputDataModalDebt();
      }
    },

    // select type of customer
    selectTypeOfCustomer({ id }) {
      switch (id) {
        case "0":
          this.paramModalAddPartner.isPerson = true;
          break;
        default:
          this.paramModalAddPartner.isPerson = false;
          break;
      }
    },

    // select type of debt in modal add debt
    selectTypeOfDebt({ id }) {
      this.paramModalAddDebt.type = id;
    },

    // submit "Hoàn tất" add debt
    async submitAddDebt() {
      // console.log(this.listPartner)
      // return
      try {
        this.messageError = new Object();
        this.paramModalAddDebt.type = this.typeOfDebt;
        this.paramModalAddDebt.title = typeof this.paramModalAddDebt.title === "string" ? this.paramModalAddDebt.title.trim() : "";
        this.paramModalAddDebt.note = typeof this.paramModalAddDebt.note === "string" ? this.paramModalAddDebt.note.trim() : "";
        this.total = typeof this.total === "string" ? this.total.trim() : this.total;
        this.key = typeof this.key === "string" ? this.key.trim() : "";
        this.paramModalAddDebt.principal = this.multiplicationThousand(+this.total);

        // console.log(111, moment(this.dateFromOfModal).startOf("day").toISOString());
        // console.log(this.total);
        // console.log(this.paramModalAddDebt);
        // return
        this.paramModalAddDebt.createdAt = moment(this.dateFromOfModal)
          .startOf("day")
          .toISOString();
        if (this.dateToOfModal) {
          this.paramModalAddDebt.dueAt = moment(this.dateToOfModal)
            .endOf("day")
            .toISOString();
        } else {
          // mặc định thêm 100 năm hạn trả 0.o
          this.paramModalAddDebt.dueAt = moment(this.dateFromOfModal)
            .add(100, "year")
            .toISOString();
        }
        //update here

        if (this.paramModalAddDebt.title === "") {
          this.messageError.title = "Vui lòng nhập nội dung";
          return;
        }
        if (this.paramModalAddDebt.type === "") {
          this.messageError.type = "Vui lòng chọn loại công nợ";
          return;
        }
        if (this.total === "" || this.total == 0) {
          this.messageError.principal = "Vui lòng nhập số tiền";
          return;
        }
        // if (this.dateToOfModal === "") {
        //   this.messageError.dueAt = "Vui lòng chọn ngày hết hạn";
        //   return;
        // }
        if (!this.partnerId) {
          this.messageError.nanme = "Vui lòng chọn khách hàng dưới danh sách";
          return;
        } else if (this.paramModalAddDebt.title.length > 60) {
          this.messageError.title = "Vui lòng nhập tối đa 60 kí tự";
          return;
        } else {
          this.loading = true;
          this.isActiveButton = true;
          //
          const result = this.listPartner.find((e) => e.id == this.partnerId);
          if (!result) {
            this.showSwalError("không tìm thấy người giao dịch");
            return;
          }
          this.paramModalAddDebt.partner = {
            partnerId: result.id,
            partnerDisplayName: result.name,
          };

          this.loading = false
          // console.log(this.paramModalAddDebt);
          // console.log(this.dateFromOfModal);
          // return
          const data = await DebtService.addNewDebt(this.paramModalAddDebt);

          if (data.success) {
            this.$bvModal.hide("modal-debt");
            this.typeAddNewSuccess = "khoản nợ";
            this.checkStatus = data.data.status;
            this.loading = false;
            // this.showModal = true;
            this.$notify({
              offset: 60,
              title: `Thêm mới khoản phải ${this.getNameOfDebt(this.typeOfDebt)} thành công`,
              message: `Khoản phải ${this.getNameOfDebt(this.typeOfDebt)} được thêm vào danh sách.`,
              type: "success",
              customClass: "notify_custom notify_custom_title",
            });
            this.fetchData();
          }
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    closeModalAddDebt() {
      this.$bvModal.hide("modal-debt");
    },

    // submit "Lưu" add Partner
    async submitAddPartner() {
      try {
        const vnf_regex = /^\d+$/;
        this.messageError = new Object();
        this.paramModalAddPartner.phoneNo = this.paramModalAddPartner.phoneNo != null ? this.paramModalAddPartner.phoneNo.trim() : null;
        this.paramModalAddPartner.email = this.paramModalAddPartner.email != null ? this.paramModalAddPartner.email.trim() : null;
        this.paramModalAddPartner.name = this.paramModalAddPartner.name.length > 0 ? this.paramModalAddPartner.name.trim() : "";

        if (this.paramModalAddPartner.name === "") {
          this.messageError.name = "Vui lòng nhập nội dung";
        } else if (this.paramModalAddPartner.name.length > 255) {
          this.messageError.name = "Vui lòng nhập tối đa 255 kí tự";
        } else if (typeof this.paramModalAddPartner.phoneNo === "string" && (this.paramModalAddPartner.phoneNo.length > 15 || this.paramModalAddPartner.phoneNo.length < 9)) {
          this.messageError.phone = "Số điện thoại không hợp lệ";
        } else if (!vnf_regex.test(this.paramModalAddPartner.phoneNo) && typeof this.paramModalAddPartner.phoneNo === "string") {
          this.messageError.phone = "Số điện thoại không hợp ";
        } else if (
          this.paramModalAddPartner.email != null &&
          (this.paramModalAddPartner.email.indexOf("@") < 1 ||
            this.paramModalAddPartner.email.lastIndexOf(".") < this.paramModalAddPartner.email.indexOf("@") + 2 ||
            this.paramModalAddPartner.email.lastIndexOf(".") + 2 >= this.paramModalAddPartner.email.length)
        ) {
          this.messageError.email = "Email không hợp lệ";
        } else {
          this.isActiveButton = true;

          this.paramModalAddPartner.merchantId = this.inforAccount.merchantId;

          const data = await CustomerServices.createCustomer(this.paramModalAddPartner);

          if (data.success) {
            // this.showModal = true;
            this.$notify({
              offset: 60,
              title: `Thành công`,
              message: `Đã thêm mới khách hàng/NCC thành công`,
              type: "success",
              customClass: "notify_custom notify_custom_title",
            });
            this.key = data.data.nanme;
            this.$bvModal.hide("modal-quick");
            this.typeAddNewSuccess = "khách hàng";

            this.listSelectPartner.push({
              partnerId: data.data.id,
              partnerName: data.data.name,
              partnerDisplayName: data.data.displayName,
              partnerPhone: data.data.phoneNo,
              partnerEmail: data.data.email,
              partnerRelationship: "",
            });

            this.clearInputDataModalPartner();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    // search Partner
    async searchPartner() {
      this.key = this.key != "" ? this.key.trim() : null;

      const data = await PartnerService.search({
        queryString: "{name} == '''" + this.key + "''' or  {id} == '''" + this.key + "''' or  {phoneNo} == '''" + this.key + "''' or  {email} == '''" + this.key + "'''",
        limit: 100,
        lastIndex: "",
        sort: "ASC",
      });
      const listSelectPartnerTmp = [];

      data.data.map((e) => {
        listSelectPartnerTmp.push({
          partnerId: e.id,
          partnerName: e.name,
          partnerDisplayName: e.displayName,
          partnerPhone: e.phoneNo,
          partnerEmail: e.email,
          partnerRelationship: "",
        });
      });

      this.listSelectPartner = listSelectPartnerTmp;
    },

    // Get list data Table
    async fetchData() {
      try {
        this.loading = true;

        this.text = this.text.length > 0 ? this.text.trim() : "";
        
        let status = '';
        if(this.statusSelected) {
          status = { eq: this.statusSelected };
        }

        const params = {
          queryString: {
            status: status,
            type: {
              eq: this.typeOfDebt,
            },
            "partner.partnerDisplayName": {
              like: this.text,
            },
            // "title": {
            //   like: this.text,
            // },
            // search api tai day
            ...(this.dueAtRange && {
              dueAt: {
                range: {
                  gte: moment(this.dueAtRange[0]).startOf("day"),
                  lte: moment(this.dueAtRange[1]).endOf("day"),
                },
              },
            }),
            ...(this.createdAtRange && {
              createdAt: {
                range: {
                  gte: moment(this.createdAtRange[0]).startOf("day"),
                  lte: moment(this.createdAtRange[1]).endOf("day"),
                },
              },
            }),
            ...(this.partnerSelectId && {
              "partner.partnerId": {
                eq: this.partnerSelectId,
              },
            }),
            ...(this.createrId && {
              "partner.createdBy": {
                eq: this.createrId,
              },
            }),
          },
          pagingAndSorting: {
            limit: 100,
            lastIndex: this.lastIndex,
            sortOrder: 1,
            ...(this.tab[0] == "SETTLED" && { sortField: "updatedAt" }),
          },
        };

        if(status == ''){ delete params.queryString.status }

        // if (this.dateRange.endDate === "" || this.startAt === "") {
        //   delete params.queryString.dueAt;
        // }

        // filter money start
        const balance = { range: {} };
        if (balance.range.lte || balance.range.gte) {
          params.queryString.balance = balance;
        } else {
          delete params.queryString.balance;
        }
        // filter money end

        // console.log(moment(this.dueAtRange[0]).startOf("day").toString())
        // console.log(moment(this.dueAtRange[1]).endOf("day").toString())
        // return
        const data = await DebtService.searchDebt(params);
        // console.log("data",data);
        if (data.success) {
          this.dataDebt = data.data.map((e) => {
            return {
              id: e.id,
              dueAt: e.dueAt,
              name: e.partner.partnerDisplayName,
              principal: e.principal,
              balance: e.balance,
              repay: e.principal - e.balance,
              status: e.status,
              createdAt: e.createdAt,
              createdBy: e.createdBy,
            };
          });
          if (data.data.length === 100) {
            const idLastIndex = data.data[99].id;
            this.lastIndex = idLastIndex;
          }
        } else {
          console.error(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // submit 'Tim Kiem' filter
    async searchDebt() {
      // if (!this.text && this.dateRange.startDate === null && this.dateRange.endDate === null) {
      //   Swal.fire({
      //     title: "Thông báo",
      //     text: "Hãy nhập giá trị tìm kiếm hoặc chọn ngày",
      //     icon: "warning",
      //   });
      //   return;
      // }
      if (this.dataDebt.length === 0) {
        this.fetchData();
      }

      if (this.dataDebt.length > 0 && this.dataDebt.length <= 100) {
        this.dataDebt.splice(0, this.dataDebt.length);
        this.fetchData();
      }

      if (this.dataDebt.length > 100) {
        this.dataDebt.splice(0, this.dataDebt.length);
        this.lastIndex = "";
      }
    },

    //Update code here
    saveItem(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          this.loading = true;
          console.log(this.dataPartner);

          const params = {
            merchantId: this.inforAccount.id,
            name: this.dataPartner.name,
            isPerson: this.dataPartner.person.id,
            phoneNo: this.dataPartner.phoneNo,
            // email: this.dataPartner.email ? this.dataPartner.email : null,
          };
          try {
            this.loading = true;
            if (this.type === "CUSTOMER") {
              const response = await CustomerServices.createCustomer(params);
              if (response.code === "SUCCESSFUL") {
                this.successmsg(response.data);
              } else if (response.code === "PHONE_EXISTED") {
                this.phoneNoExistedMsg(response.data);
              }
            } else if (this.type === "SUPPLIER") {
              const response = await SupplierServices.createrSupplier(params);
              if (response.code === "SUCCESSFUL") {
                this.successmsg(response.data);
              } else if (response.code === "PHONE_EXISTED") {
                this.phoneNoExistedMsg(response.data);
              }
            } else if (this.type === "SHIPPER") {
              const response = await SupplierServices.createNewShipper(params);
              if (response.code === "SUCCESSFUL") {
                this.successmsg(response.data);
              } else if (response.code === "PHONE_EXISTED") {
                this.phoneNoExistedMsg(response.data);
              }
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },

    destroyModal() {
      this.modalNewCustomer = false;
      this.modalSuccess = false;
      this.dataPartner = {
        name: "",
        person: { id: true, text: "Cá nhân" },
      };
    },
    //Modal Success
    successmsg(data) {
      Swal.fire({
        title: "Thành công",
        text: `Đã tạo mới người giao dịch thành công!`,
        icon: "success",
        confirmButtonText: "Xác nhận",
      }).then(() => {
        console.log(data);

        this.partner = data;
        this.partnerId = data.id;
        this.listPartner.push(data);
        // this.getlistPartner();
        this.modalNewCustomer = false;
        this.resetAddPartner();
      });
    },
    resetAddPartner() {
      this.dataPartner.name = "";
      this.type = {
        id: "CUSTOMER",
        text: "Khách hàng",
      };
      this.dataPartner.phoneNo = "";
    },
    //Modal PhoneNO existed
    phoneNoExistedMsg(data) {
      Swal.fire({
        title: "Thất bại",
        text: `Số điện thoại đã tồn tại. Bạn có muốn thêm người giao dịch ${data.name} - ${data.phoneNo} vào khoản nợ này.`,
        icon: "error",
        confirmButtonText: "Nhập lại thông tin",
        cancelButtonText: "Sử dụng ngay",
        showCancelButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.dataPartner.phoneNo = null;
        } else {
          this.partner = data;
          this.destroyModal();
        }
      });
    },
    cancelAdd() {
      if (this.dataPartner.name.length !== 0) {
        Swal.fire({
          title: "Hủy tạo mới",
          text: "Xác nhận hủy tạo mới",
          icon: "warning",
          confirmButtonText: "Xác nhận",
        }).then((result) => {
          if (result) {
            this.destroyModal();
          }
        });
      } else {
        this.destroyModal();
      }
    },
    // async getlistPartner() {
    //   try {
    //     this.loading = true;
    //     const response = await CustomerServices.getListAllPartner({
    //       query: "",
    //       merchantId: this.inforAccount.id,
    //       person: 2,
    //       sort: "date",
    //     });
    //     this.listPartner = response.data;

    //     //
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async exportData() {
      try {
        const params = {
          merchantId: this.search.merchantId,
          type: this.typeOfDebt,
        };
        this.loading = true;
        const response = await DebtService.exportData(params);
        if (response.status == 200) {
          Swal.fire({
            title: "Xuất dữ liệu thành công",
            text: `Dữ liệu danh sách đơn hàng sẽ được tải về thiết bị của bạn`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then((result) => {
            if (result.value) {
              this.fetchData();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async uploadFileExcel() {
      const allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;
      const checkFomat = allowedExtensions.exec(this.$refs.file.value);

      this.fileName = this.$refs.file.files[0].name;
      this.messFailFormat = "";
      this.formData = new FormData();
      this.formData.append("file", this.$refs.file.files[0]);
      this.formData.append("merchantId", this.search.merchantId);

      if (!checkFomat) {
        this.keyCheckUpload = 2;
        this.messFailFormat = "Định dạng không hợp lệ !";
        this.fileName = "";
      } else {
        this.keyCheckUpload = 1;
      }
    },

    async importData() {
      try {
        if (this.formData === null) {
          this.messFailFormat = "Vui lòng chọn file tải lên !";
          return false;
        }
        this.isUpload = true;
        const response = await DebtService.importData(this.formData);

        let _title = "";
        let _icon = "";
        if (response.success == false) {
          _title = "Nhập dữ liệu lỗi";
          _icon = "error";
        } else {
          _title = "Nhập dữ liệu thành công";
          _icon = "success";
        }

        if (response.status == 200) {
          this.isUpload = false;
          Swal.fire({
            title: _title,
            text: response.data.data.message,
            icon: _icon,
            confirmButtonText: "Xác nhận",
            closeOnClickOutside: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.value) {
              this.fetchData();
              this.cancels();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    cancels() {
      this.fileName = "";
      this.keyCheckUpload = 0;
      this.messFailFormat = "";
      this.formData = null;
      this.modalImport = false;
    },
    getNameOfDebt(typeOfDebt, upperCase) {
      if (upperCase) {
        return typeOfDebt === "lending" ? "THU" : "TRẢ";
      }
      return typeOfDebt === "lending" ? "thu" : "trả";
    },
    getStartTimeToday() {
      return new Date();
    },

    // danh sách người tạo
    async getListCreaterInHere() {
      this.listCreater = await getListCreater();
      this.mapListCreater = arrayToObjectKey(this.listCreater, "id");
    },

    async remoteMethod(query) {
      const textSearch = query.trim()
      if (textSearch !== "") {
        const params = {
          pageNum: 1,
          pageSize: 20,
          sortBy: "_id",
          sortType: "DESC",
          isPerson: true,
          ...(textSearch && { textSearch }),
        };

        try {
          this.loadingSelect = true;
          const response = await CustomerServices.getListCustomerPagging(params);
          if (response.success) {
            this.listPartner = response.data.data;
          }
          this.loading = false;
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingSelect = false;
        }
      } else {
        this.options = [];
      }
    },
    async chooseOption(event, item) {
      this.activeItem = item;
      await this.getDataDetailDebt(item.id);
      await this.getDataHistoryPay(item.id)
      if(event == 'Sửa thông tin') {
        this.$bvModal.show('editDetailDebt')
      } else {
        this.$bvModal.show('modal-pay')
      }
    },

    getDateOfModalAddPay(item) {
      const dateTo = new Date(item);
      this.paramAddPay.occurAt = dateTo.toISOString();
    },

    checkTotal() {
      if (this.total === "") {
        this.messEror.total = "Vui lòng nhập số tiền";
        return (this.checkTotal1 = false);
      } else if (parseInt(new String(this.total).replace(/,/g, "")) > parseInt(this.dataDetail.balance)) {
        this.messEror.total = "Vui lòng nhập số tiền không lớn hơn số tiền còn lại";
        return (this.checkTotal1 = false);
      } else {
        this.messEror.total = "";
        return (this.checkTotal1 = true);
      }
    },
    checkDate() {
      if (this.dateOfModal === "") {
        this.messEror.dateOfModal = "vui lòng nhập ngày";
        return (this.checkDate1 = false);
      } else {
        this.messEror.dateOfModal = "";
        return (this.checkDate1 = true);
      }
    },

    async submitAddPay() {
      try {
        const string = new String(this.total);
        this.messEror = new Object();
        this.paramAddPay.repayAmount = this.multiplicationThousand(string);
        const param = `{method:` + this.formOfPayment + `}`;
        this.paramAddPay.sourceKey = `${param}`;
        this.paramAddPay.referenceCode = this.referenceCode;
        this.paramAddPay.note = typeof this.paramAddPay.note === "string" ? this.paramAddPay.note.trim() : this.dataDetailTmp.title;
        this.total = typeof this.total === "string" ? this.total.trim() : string;
        this.checkTotal();
        this.checkDate();
        if (this.checkTotal1 && this.checkDate1) {
          this.$bvModal.show("modal-pay-confirm")
          // return
          // this.submitAddPayConfirm()
        }
      } catch (error) {
        console.log(error);
      }
    },
    async submitAddPayConfirm() {
      this.paramAddPay.id = this.activeItem.id;
      try {
        this.loading = true;
          const data = await DebtService.addNewPay(this.paramAddPay);
          if (data.success) {
            this.$bvModal.hide("modal-pay");
            this.$bvModal.hide("modal-pay-confirm");
            // this.showModal = true;
            this.fetchData();
            this.$notify({
              offset: 60,
              title: `Thêm mới thanh toán thành công`,
              message: `Khoản thanh toán đã được thêm.`,
              type: "success",
              customClass: "notify_custom notify_custom_title",
            });
          }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }

    },

    closeModalUpdate() {
      this.messEror = new Object();
      this.$bvModal.hide("editDetailDebt");
      this.dataDetailTmp.title = this.dataDetail.title;
      this.dataDetailTmp.note = this.dataDetail.note;
      this.startAt = this.dataDetail.startAt.slice(0, 10);
      this.dueAt = this.dataDetail.dueAt.slice(0, 10);
    },

    async clickEdit() {
      try {
        this.loading = true;
        this.messEror = new Object();
        this.dataDetailTmp.title = typeof this.dataDetailTmp.title === "string" ? this.dataDetailTmp.title.trim() : this.dataDetailTmp.title;
        this.dataDetailTmp.note = typeof this.dataDetailTmp.note === "string" ? this.dataDetailTmp.note.trim() : this.dataDetailTmp.title;

        if (this.dataDetailTmp.startAt === "") {
          this.dataDetailTmp.startAt = null;
        }
        if (this.dataDetailTmp.title === "") {
          this.messEror.title = "Vui lòng nhập nội dung";
        }
        if (this.dataDetailTmp.startAt === "1970-01-01T00:00:00.000Z") {
          delete this.dataDetailTmp.startAt;
        } else {
          this.dataDetailTmp.id = this.activeItem.id;
          const response = await DebtService.update(this.dataDetailTmp);

          if (response.success) {
            this.fetchData();
            this.$notify({
              offset: 60,
              title: `Chỉnh sửa khoản ${this.getNameOfDebt(this.typesDebt)} thành công`,
              message: `Thông tin khoản ${this.getNameOfDebt(this.typesDebt)} đã được chỉnh sửa.`,
              type: "success",
              customClass: "notify_custom notify_custom_title",
            });
            this.$bvModal.hide("editDetailDebt");
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    check() {
      const d = new Date(this.startAt);
      d.setDate(new Date(this.startAt).getDate() - 1);
      return ($event) => (this.dueAt ? $event < d : false);
    },

    disableForDueAt(date) {
      return date < new Date(this.startAt + "T00:00:00");
    },

    async getDataHistoryPay(item) {
      try {
        this.paramAddPay.sourceId = this.dataDetail.partner.partnerId;

        const data = await DebtService.getHistoryPay(item);
        this.items = data.data;

        if (data.data.length > 0) {
          const arrDate = [];
          for (let i = 1; i <= data.data.length; i++) {
            const date = Date.parse(data.data[i - 1].occurAt);
            arrDate.push(date);
          }

          const minDateFormatMls = Math.min.apply(Math, arrDate);
          this.minDate = new Date(minDateFormatMls).toISOString();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getDataDetailDebt(item) {
      try {
        this.loading = true;
        const data = await DebtService.getDebtDetail(item);
        if (data.success) {
          this.typeOfDebt = data.data.type;
          if (data.data.balance === 0) {
            this.showModalPay = false;
          }

          this.paramAddPay.occurAt = new Date().toISOString();
          this.dueAt = data.data.dueAt;
          this.total = this.divisionThousand(+data.data.balance);
          this.dataDetail = {
            ...data.data,
            principal: this.divisionThousand(+data.data.principal),
            balance: this.divisionThousand(+data.data.balance),
            currency: data.data.currency,
          };
          this.dataDetailTmp = {
            status: data.data.status,
            title: data.data.title,
            partner: {
              partnerId: data.data.partner.partnerId,
              partnerDisplayName: data.data.partner.partnerDisplayName,
            },
            type: data.data.type,
            note: data.data.note,
            dueAt: data.data.dueAt,
            startAt: data.data.startAt,
            principal: this.divisionThousand(+data.data.principal),
            balance: this.divisionThousand(+data.data.balance),
            currency: data.data.currency,
          };

          this.dueAt = data.data.dueAt.slice(0, 10);
          this.startAt = data.data.startAt.slice(0, 10);
        } else {
          console.log(data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async mcReportV3(){
      const response = await ReportService.mcReportV3(this.MID)
      if(response.success){
        const dataDebtNote = response.data
        if(this.typeOfDebt == 'lending'){
          this.dataReport[0].value = this.formatMoneyNotUnit(this.divisionThousand(dataDebtNote.lending.totalAmount))
          this.dataReport[1].value = this.formatMoneyNotUnit(this.divisionThousand(dataDebtNote.lending.totalAmount - dataDebtNote.lending.paidAmount))
        }else{
          this.dataReport[0].value = this.formatMoneyNotUnit(this.divisionThousand(dataDebtNote.borrowing.totalAmount))
          this.dataReport[1].value = this.formatMoneyNotUnit(this.divisionThousand(dataDebtNote.borrowing.totalAmount - dataDebtNote.borrowing.paidAmount))
        }
      }
    }
  },
};
</script>

<style lang="scss" scope>
.emptyData {
  height: 300px;

  p {
    color: #ddd;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    padding-top: 165px;
  }
}
.modal-header {
  background-color: #f1f1f1;
  .title-modal-addDebt {
    font-size: 18px;
    font-weight: 600 !important;
  }
}
</style>

<style lang="scss">
// moi
.form-control:disabled {
  background-color: #f5f7fa;
  cursor: not-allowed;
}
.custom-input-77 {
  .el-input {
    // height: 36px;
  }
  .el-input.is-focus .el-input__inner {
    // border-color: #ced4da !important;
  }
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent !important;
}
.notify_custom_title {
  width: 360px;
}

.step-content {
  text-align: center;
  border: 2px dashed #ced4da;
  padding: 80px 0;
  margin: 20px 0 0;
  width: 100%;
  cursor: pointer;
}
.input-file-containers {
  font-size: 14px;
  color: #ced4da;
  cursor: pointer;
}
.input-file-containers .bxs-cloud-upload {
  font-size: 20px;
  position: relative;
  top: 3px;
  cursor: pointer;
}
</style>
